var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4909 6.93479C18.6407 7.06556 18.7325 7.25048 18.746 7.44888C18.7595 7.64728 18.6936 7.84292 18.5629 7.99279L10.7059 16.9928C10.6355 17.0734 10.5487 17.1381 10.4512 17.1824C10.3538 17.2266 10.248 17.2496 10.1409 17.2496C10.0339 17.2496 9.92808 17.2266 9.83063 17.1824C9.73317 17.1381 9.64633 17.0734 9.57593 16.9928L6.43293 13.3928C6.30685 13.2423 6.2448 13.0484 6.26009 12.8527C6.27538 12.657 6.3668 12.4751 6.51471 12.346C6.66263 12.2169 6.85525 12.151 7.05123 12.1624C7.24721 12.1737 7.43093 12.2615 7.56293 12.4068L10.1409 15.3598L17.4329 7.00679C17.5637 6.85698 17.7486 6.76523 17.947 6.75173C18.1454 6.73823 18.3411 6.80408 18.4909 6.93479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUnread);
export default __webpack_public_path__ + "static/media/message_unread.d405837800bc66c2ea83711d1b3970c2.svg";
export { ForwardRef as ReactComponent };